import type { LedgerService } from '.';
import delay from '../mockServiceDelay';

export const mockLedgerService: LedgerService = {
  fetchLedger: async () => {
    await delay();
    return [];
  },
  fetchLedgerByAsset: async () => {
    await delay();
    return [];
  },
  fetchGenericAssets: async () => {
    await delay();
    return [];
  },
  fetchGenericAssetsV2: async () => {
    await delay();
    return [];
  },
};
